"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEulaAsMarkdown = exports.eulaContentTagsToMarkdown = exports.eulaTitleTagsToMarkdown = exports.replace = void 0;
exports.replace = (title, replacements) => {
    let next = title;
    replacements.forEach(obj => {
        next = next.replace(obj.pattern, obj.replacement);
    });
    return next;
};
const titleTagsReplacements = [
    {
        pattern: /\n/gi,
        replacement: ''
    },
    {
        pattern: /<EULA\.HighlightItalic>([^<]*)<\/>/gi,
        replacement: '$1'
    },
    {
        pattern: /<EULA\.Header>([^<]*)<\/>/gi,
        replacement: '$1'
    },
    {
        pattern: /<EULA\.SubHeader>([^<]*)<\/>/gi,
        replacement: '$1'
    },
    {
        pattern: /<EULA\.Highlight>([^<]*)<\/>/gi,
        replacement: '$1'
    }
];
const contentTagsReplacements = [
    {
        pattern: /<a.*href="([^"]*)".*>([^<]*)<\/>/gi,
        replacement: '[$2]($1)'
    },
    {
        pattern: /<EULA\.HighlightItalic>([^<]*)<\/>/gi,
        replacement: '**__$1__**'
    },
    {
        pattern: /<EULA\.Header>([^<]*)<\/>\n?\n?/gi,
        replacement: '# $1\n\n'
    },
    {
        pattern: /<EULA\.SubHeader>([^<]*)<\/>\n?\n?/gi,
        replacement: '## $1\n\n'
    },
    {
        pattern: /<EULA\.Highlight>([^<]*)<\/>/gi,
        replacement: '**$1**'
    },
    {
        // Prevent accidental lists from being created
        // 1. License Grant
        pattern: /(\d+)\.([\s\\])/gi,
        replacement: '$1\\.$2'
    }
];
exports.eulaTitleTagsToMarkdown = (title) => exports.replace(title, titleTagsReplacements);
exports.eulaContentTagsToMarkdown = (title) => exports.replace(title, contentTagsReplacements);
exports.formatEulaAsMarkdown = (eulaResponse) => {
    const convertedEula = Object.assign({}, eulaResponse);
    if (convertedEula.title) {
        convertedEula.title = exports.eulaTitleTagsToMarkdown(convertedEula.title);
    }
    if (convertedEula.body) {
        convertedEula.body = exports.eulaContentTagsToMarkdown(convertedEula.body);
    }
    return convertedEula;
};
//# sourceMappingURL=EulaMarkdownUtils.js.map